
import { AdminTemplate, MerchantMonthlyTransactionAmountComponent } from "../../components";

export const MerchantMonthlyTransactionAmount = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "Üye İşyeri Aylık İşlem Tutarı",
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: true,
            }}
            showHeaderTitle={true}>
            <MerchantMonthlyTransactionAmountComponent />
        </AdminTemplate>
    );
};
